import { useState } from 'react';
import {
	Avatar,
	Box,
	Divider,
	IconButton,
	ListItemIcon,
	Menu,
	MenuItem,
	Typography,
	useTheme,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

export default function UserMenu() {
	const theme = useTheme();
	const { user } = useSelector((state: RootState) => state.auth);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => setAnchorEl(null);

	return (
		<Box>
			{/* Avatar button for all screen sizes */}
			<IconButton
				onClick={handleClick}
				size="small"
				sx={{
					ml: 1,
					border: `2px solid ${theme.palette.divider}`,
					p: 0.5,
					borderRadius: '50%',
					backgroundColor: theme.palette.background.paper,
					'&:hover': {
						backgroundColor: theme.palette.action.hover,
					},
				}}
			>
				<Avatar sx={{ width: 24, height: 24, bgcolor: theme.palette.primary.main }}>
					{user?.username?.[0]?.toUpperCase() ?? <AccountCircleIcon fontSize="small" />}
				</Avatar>
			</IconButton>

			{/* Dropdown menu */}
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				PaperProps={{
					elevation: 4,
					sx: {
						mt: 1.5,
						borderRadius: 2,
						minWidth: 220,
						overflow: 'visible',
						'& .MuiAvatar-root': {
							width: 28,
							height: 28,
							ml: -0.5,
							mr: 1,
						},
					},
				}}
			>
				{/* User header */}
				<Box sx={{ px: 2, py: 1 }}>
					<Typography variant="subtitle1" fontWeight={600}>
						{user?.username ?? 'User'}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{user?.username ?? 'No email set'}
					</Typography>
				</Box>
				<Divider sx={{ my: 1 }} />

				{/* Menu items */}
				<MenuItem>
					<ListItemIcon>
						<PersonRoundedIcon fontSize="small" />
					</ListItemIcon>
					Profile
				</MenuItem>
				<MenuItem>
					<ListItemIcon>
						<SettingsRoundedIcon fontSize="small" />
					</ListItemIcon>
					Settings
				</MenuItem>
				<Divider />
				<MenuItem onClick={window.logout}>
					<ListItemIcon>
						<LogoutRoundedIcon color="error" fontSize="small" />
					</ListItemIcon>
					Logout
				</MenuItem>
			</Menu>
		</Box>
	);
}
